export default __webpack_public_path__ + "static/media/shiny-iris.d4d49b80.svg";